var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('h1',{staticClass:"header__logo"},[_c('Logo',{attrs:{"width":"160","height":"40"}})],1),_c('div',{staticClass:"header__operation-area"},[_c('HeaderUserInfo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }